import React, { PureComponent } from "react";

export default class AlgoliaCredit extends PureComponent {
    render() {
        return (
            <img
                src={require("~/images/logos/search-by-algolia-light-background-8762ce8b.svg")}
                className="algolia-credit"
            />
        );
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/AlgoliaCredit.js